// Token tracking utility for user identification

const TOKEN_STORAGE_KEY = 'user_tracking_token';
const TOKEN_URL_PARAM = 'token';

/**
 * Extract token from URL parameters
 * @returns {string|null} The token if found, null otherwise
 */
export const extractTokenFromURL = () => {
  if (typeof window === 'undefined') return null;

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get(TOKEN_URL_PARAM);

  return token;
};

/**
 * Get the current user token from storage or URL
 * @returns {string|null} The user token
 */
export const getUserToken = () => {
  if (typeof window === 'undefined') return null;

  // First, check if there's a token in the URL (takes priority)
  const urlToken = extractTokenFromURL();
  if (urlToken) {
    // Store it for future use
    localStorage.setItem(TOKEN_STORAGE_KEY, urlToken);
    return urlToken;
  }

  // Otherwise, check localStorage
  return localStorage.getItem(TOKEN_STORAGE_KEY);
};

/**
 * Initialize token tracking - should be called on app load
 * @returns {string|null} The user token
 */
export const initializeTokenTracking = () => {
  const token = getUserToken();

  if (token) {
    console.log('✅ User tracking token initialized:', token);
    console.log('📊 Token stored in localStorage. All analytics events will include this token.');

    // Remove token from URL to keep it clean (optional)
    if (window.location.search.includes(`${TOKEN_URL_PARAM}=`)) {
      const url = new URL(window.location);
      url.searchParams.delete(TOKEN_URL_PARAM);
      window.history.replaceState({}, '', url);
      console.log('🧹 Token removed from URL (stored in localStorage)');
    }
  } else {
    console.log('ℹ️ No user tracking token found in URL or localStorage');
  }

  return token;
};

/**
 * Clear the stored token
 */
export const clearUserToken = () => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
  }
};

/**
 * Check if a token exists
 * @returns {boolean} True if token exists
 */
export const hasUserToken = () => {
  return getUserToken() !== null;
};
